import axios from 'axios';
export async function checkFrameStock(sku, rebateSize, quantity = 1) {
    const { data } = await axios
        .get('/api/materials/moulding/isFrameInStock', {
        params: {
            sku,
            rebateWidth: rebateSize.width,
            rebateLength: rebateSize.length,
            quantity
        }
    });
    return data.success;
}
export async function checkMountStock(sku, externalSize, quantity = 1) {
    if (externalSize.length * externalSize.width <= 0) {
        return false;
    }
    const { data } = await axios
        .get('/api/materials/mountboard/isInStock', {
        params: {
            sku,
            width: externalSize.width,
            length: externalSize.length,
            quantity
        }
    });
    return data.success;
}
export async function checkSheetStock(sku, size, quantity = 1) {
    try {
        await axios.get('/api/materials/sheets/isInStock', {
            params: {
                sku,
                width: size.width,
                length: size.length,
                quantity
            }
        });
    }
    catch (e) {
        return false;
    }
    return true;
}
export async function checkUnitStock(sku, packSize, quantity = 1) {
    try {
        await axios.get('/api/materials/units/isInStock', {
            params: {
                sku,
                packSize,
                quantity
            }
        });
    }
    catch (e) {
        return false;
    }
    return true;
}
export async function checkLengthStock(sku, packType = 'length', quantity = 1) {
    try {
        await axios.get('/api/materials/lengths/isInStock', {
            params: {
                sku,
                packType,
                quantity
            }
        });
    }
    catch (e) {
        return false;
    }
    return true;
}
